export enum MobileDrawerPanel {
  SELECTOR_PANEL = 'SELECTOR_PANEL',
  SEARCH_PANEL = 'SEARCH_PANEL',
  SORT_PANEL = 'SORT_PANEL',
  SUBMIT_PANEL = 'SUBMIT_PANEL',
  DROPOFF_DETAIL_PANEL = 'DROPOFF_DETAIL_PANEL'
}


declare global {
  interface Window {
    _env_?: {
      REACT_APP_WOOSMAP_PUBLIC_KEY?: string
      REACT_APP_BACKEND_API_URL?: string
      REACT_APP_TENANT_ID?: string
      REACT_APP_GOOGLE_PLACE_API_KEY?: string
    }
    tenantId?: string
  }
}
